<template>
  <v-container>
    <v-skeleton-loader v-if="$apollo.loading || !banner_area" type="card-heading, list-item, image@2, list-item-three-line@5" />
    <v-card v-else class="pa-5">
      <h3 class="text-h3 mb-10">
        {{ banner_area.name }}
      </h3>
      <div>
        <v-chip>Slug: {{ banner_area.slug }}</v-chip>
        <v-chip>Статус: {{ banner_area.status }}</v-chip>
      </div>
      <v-divider class="my-7" />
      <template v-for="image in images">
        <p :key="image.file.url" class="text-h5">
          {{ image.file.url }}:
        </p>
        <v-img :key="image.url" :src="image.url" :alt="image.alt" max-height="500" max-width="600" />
      </template>
      <p class="text-h5 mt-5">
        Краткое описание:
      </p>
      <div class="px-5" v-html="banner_area.description" />
    </v-card>
  </v-container>
</template>

<script>
import { banner_area } from '@/graphql/banners'
import { isEmpty } from 'lodash-es'

export default {
  name: 'Banner',
  layout: 'dashboard',
  apollo: {
    banner: {
      query: banner_area,
      variables () {
        return {
          slug: String(this.$route.params.slug)
        }
      }
    }
  },
  computed: {
    images () {
      return isEmpty(this.banner)
        ? []
        : [
            ['Изображение', this.banner.image]
          ]
              .map(([title, image]) => ({ title, url: image.file.url, alt: image.alt }))
    }
  },
  methods: {
    formatTimestamp (timestamp) {
      return new Date(timestamp * 1000).toLocaleString('ru-RU')
    }
  }
}
</script>

<style scoped>

</style>
